// Utilities related to our entity version's ...VersionExtraData and ...DataSnapshot types.

/**** VERSIONING ****/
// NOTE: The following is NOT intended as a generic/all-purpose solution for ANY situation in
// which we might wanna version JSON. Instead, it's tailored for the conventions we use
// server-side for versioning our ...VersionExtraData and ...DataSnapshot types. If we someday
// want a generic/all-purpose solution, the following might be useful as a start, but it will
// probably need some revising.

/**
 * The property key that our server-side `...VersionExtraData` and `...DataSnapshot` types use
 * to communicate their version number.
 */
export type VERSION_FLAG_KEY = "v";

/**
 * A type with a required version flag that could be any number. Typewriter generates
 * `...VersionExtraData_vNData` and `...DataSnpahost_vNData` types that are assignable to this
 * type.
 */
export type ServerVersionFlag = { [K in VERSION_FLAG_KEY] : number; };

/**
 * A type that matches the provided `TData` type except that it has a required version flag
 * of the provided `TFlag` type (which can be narrower than type `number`). Use when all
 * JSON of the given version is known to possess a version flag.
 */
export type ReqVersionFlag<TFlag extends number, TData extends ServerVersionFlag> =
    TData & { [K in VERSION_FLAG_KEY] : TFlag; };

/**
 * A type that matches the provided `TData` type except that it has an optional version flag
 * of the provided `TFlag` type (which can be narrower than type `number`). Use when JSON of
 * the given version may or may not possess a version flag (i.e. the version precedes the
 * introduction of our JSON versioning system).
 */
export type OptVersionFlag<TFlag extends number, TData extends ServerVersionFlag> =
    Omit<TData, VERSION_FLAG_KEY> & { [K in VERSION_FLAG_KEY]? : TFlag; };


/**** PARSING ExtraDataJSON ****/
/**
 * JSON parse the provided `json` and cast as the given `TOutput` type, unless the `json` is
 * `null`, in which case return `null`.
 */
export function parseIfNonNull<TOutput>(json : string | null) {
    return json === null ? null : JSON.parse(json) as TOutput;
}



// WEBPACK FOOTER //
// ./data/models/ExtraDataUtils.ts